// extracted by mini-css-extract-plugin
export default {"vertical-icon":"styles_vertical-icon__14OCX"};